import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useFilters } from 'hooks/useFilters';
import { useQueryParam } from 'hooks/useQueryParam';
import ClientsSelect from 'components/ClientsSelect';
import { ReloadOutlined } from '@ant-design/icons';
import { ActionsWrapper } from 'ui/ActionsWrapper';
import { FETCH_ERROR } from 'constants/alerts';
import { ClientsService } from 'services/ClientsService';
import { ClientsLogsTable } from './ClientsLogsTable';

const PAGE_TITLE = 'Логи';

function ClientsLogs() {
  useDocumentTitle(PAGE_TITLE);
  const clientId = useQueryParam('client_id');
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { filters, handleFilters, resetFilters } = useFilters({
    client_id: '',
    f_date: null,
    t_date: null,
    method: null,
  });
  const {
    page,
    perPage,
    totalRows,
    setPagination,
    setTotalRows,
    resetPagination,
  } = usePagination();
  const { setCount } = useHeaderChanger(PAGE_TITLE);

  useEffect(() => {
    fetchLogs();
  }, [page, perPage, filters]);

  const fetchLogs = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await ClientsService.getClientsLogs(
        page,
        perPage,
        filters
      );

      setLogs(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleClientSelect = (id = '') => {
    resetFilters();
    handleFilters({ client_id: id });
    resetPagination();
  };

  return (
    <>
      <ActionsWrapper>
        <ClientsSelect
          pageTitle={PAGE_TITLE}
          clientId={clientId}
          onSelect={handleClientSelect}
          onClear={handleClientSelect}
        />

        <Button type="primary" icon={<ReloadOutlined />} onClick={fetchLogs}>
          Обновить
        </Button>
      </ActionsWrapper>

      <ClientsLogsTable
        loading={loading}
        items={logs}
        filters={filters}
        current={page}
        pageSize={perPage}
        totalRows={totalRows}
        onChange={setPagination}
        onFilter={(value) => {
          handleFilters(value);
          resetPagination();
        }}
      />
    </>
  );
}

export { ClientsLogs };
